import { useRouteContext, useSearch, useNavigate } from "@tanstack/react-router";
import { ExclamationCircle } from "@repo/icons";
import { ServicePackageEnum } from "@repo/lib";
import { Button } from "@/components/button";
import {
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/empty-state";
import { trackEvent } from "@/lib/tracking";

export const BillingListEmptyState = (): JSX.Element => {
  const { user } = useRouteContext({ strict: false });
  const params = useSearch({ from: "/settings/billing/" });
  const navigate = useNavigate();

  const isProUser = user.pacotesServicos.find(
    (servicePkg) => servicePkg.codPacoteServicos === ServicePackageEnum.Pro.valueOf(),
  );

  const isLegacyUser = user.pacotesServicos.find(
    (servicePkg) => servicePkg.codPacoteServicos === ServicePackageEnum.Legacy.valueOf(),
  );

  const isAssistFilter = params.selectedFilter === "assist";

  const handleAssistProButtonClick = (): void => {
    trackEvent("Conhecer Assist Pro Clicado");

    const subscribeUrl = isLegacyUser
      ? "/settings/assist/subscribe-assist-pro-legacy"
      : "/settings/assist/subscribe-assist-pro";

    void navigate({
      to: subscribeUrl,
      search: { navigateBack: true },
    });
  };

  if (isAssistFilter && !isProUser) {
    return (
      <EmptyStateRoot>
        <EmptyStateIcon icon={ExclamationCircle} />
        <EmptyStateTitle>Você ainda não contratou o Assist Pro</EmptyStateTitle>
        <EmptyStateDescription>
          Descubra como o Assist Pro pode simplificar sua rotina e acelerar o crescimento
          do seu consultório.
        </EmptyStateDescription>
        <Button fullWidth onClick={handleAssistProButtonClick}>
          Quero conhecer o Assist Pro
        </Button>
      </EmptyStateRoot>
    );
  }

  return (
    <EmptyStateRoot>
      <EmptyStateIcon icon={ExclamationCircle} />
      <EmptyStateTitle>Nenhuma movimentação encontrada</EmptyStateTitle>
      <EmptyStateDescription>
        Tente alterar os filtros ou selecionar outro mês para continuar a busca.
      </EmptyStateDescription>
    </EmptyStateRoot>
  );
};
